/**
 * ClinicalHUD access subscription — clinicalHudAccess/{uid}.
 */
import { db } from 'services/firebase';

export function subscribeToClinicalHudAccess(uid, onData, onError) {
  if (!uid) {
    onData(null);
    return () => {};
  }
  return db
    .collection('clinicalHudAccess')
    .doc(uid)
    .onSnapshot(
      (snap) => {
        onData(snap.exists ? snap.data() : null);
      },
      (err) => {
        console.warn('[clinicalHudAccess] subscription failed');
        if (typeof onError === 'function') onError(err);
        else onData(null);
      },
    );
}
